<template>
  <div class="register_bg">
    <div v-if="show_register" class="register-container">
      <h2 class="page-title">註冊帳號</h2>
      <div class="form-content">
        <form @submit.prevent="handleSubmit">
          <!-- 單欄佈局 -->
          <div class="form-card">
            <div class="two-columns">
              <div class="form-group">
                <label for="username">帳號（手機號碼）:</label>
                <input type="text" id="username" v-model="username" placeholder="輸入您的手機號碼作為帳號" required
                  class="font-control" />
              </div>
              <div class="form-group">
                <label for="password">密碼:</label>
                <input type="password" id="password" v-model="password" placeholder="輸入您的密碼" required
                  class="font-control" />
              </div>
              <div class="form-group">
                <label for="confirmPassword">再次輸入密碼:</label>
                <input type="password" id="confirmPassword" placeholder="輸入您的密碼" v-model="confirmPassword" required
                  class="font-control" />
              </div>
            </div>
            <button type="submit" class="form-submit-btn">註冊帳號</button>

          </div>

          <p class="register-link">
            已有帳號？
            <router-link to="/login-page">登入</router-link>
          </p>

        </form>
      </div>
    </div>

    <div v-if="show_verify" class="register-container">

      <h2 class='page-title'>驗證您的帳號</h2>
      <div class="form-content">
        <form @submit.prevent="verifyCode">
          <!-- 單欄佈局 -->
          <div class="form-card">
            <div class="two-columns">
              <div class="form-group">
                <label for="verificationCode">驗證碼:</label>
                <input type="text" id="verificationCode" placeholder="輸入驗證碼" v-model="verificationCode" required
                  class="font-control" />
              </div>
              <button type="submit" class="form-submit-btn">驗證</button>
              <!-- <button type="button" class="form-submit-btn" @click="resendVerificationCode">重新發送驗證碼</button> -->
            </div>
          </div>
        </form>
      </div>
    </div>

  <div style="min-height: 80vh;">
  <ShowSuccess v-if="show_success" />
</div>

  <ContactFooter />
  </div>
</template>

<script>
import ContactFooter from "@/components/ContactFooter.vue";
import ShowSuccess from "./ShowSuccess.vue";

import { mapActions } from "vuex";

import MemberDAO from "../../services/MemberDAO";

const memberDAO = new MemberDAO(process.env.VUE_APP_HTTP_BASE_URL);

export default {
  name: "UserRegister",
  components: {
    ContactFooter,
    ShowSuccess,
  },

  data() {
    return {
      show_register: true,
      show_verify: false,
      show_success: false,
      curModal: "register",
      username: "",
      password: "",
      confirmPassword: "",
      verificationCode: "",
      correct_verficationCode: "",
    };
  },
  methods: {
    ...mapActions(["register"]),
    async handleSubmit() {
      if (this.password !== this.confirmPassword) {
        alert("密碼不匹配！");
        return;
      }

      console.log("註冊信息:", this.username, this.password);

      // this.show_register = false;
      // this.show_verify = true;
      // 創建一個6位數的隨機數並轉換為字符串
      this.correct_verficationCode = Math.floor(
        100000 + Math.random() * 900000
      ).toString();

      const smsRst = await this.sendVeriCode();
      if (smsRst) {
        this.show_register = false;
        this.show_verify = true;
      }

    },
    verifyCode() {
      console.log("驗證碼:", this.verificationCode);
      if (this.verificationCode !== this.correct_verficationCode) {
        alert("驗證碼不正確！");
        return;
      }
      this.attemptRegister();
    },

    async sendVeriCode() {
      // 示例用法
      const phoneNumber = this.username;
      // const message = "Your verification code is " + this.correct_verficationCode;
      // const message = "[台灣聯通停車場]請在10分鐘內於驗證網頁輸入『{}』完成驗證,密碼請勿提供他人以防詐騙。";
      const message = `[台灣聯通停車場]請在10分鐘內於驗證網頁輸入『${this.correct_verficationCode}』完成驗證,密碼請勿提供他人以防詐騙。`;

      try {
        await memberDAO.sendSms(phoneNumber, message);
        console.log("發送SMS成功");
        return true;
      } catch (error) {
        console.error("發送SMS時出錯:", error);
        alert("發送SMS時出錯:");
        return false;
      }
    },

    async attemptRegister() {
      try {
        const rst = await memberDAO.register(this.username, this.password);
        console.log("attempt register rst:", rst);
        if (rst.success) {
          console.log("註冊成功");
          this.show_verify = false;
          this.show_success = true;
          this.show_register = false;
        } else {
          alert("註冊失敗" + rst.message);
          console.error("註冊失敗:", rst.message);
          this.show_register = true;
          this.show_verify = false;
          this.show_success = false;
        }
      } catch (error) {
        alert("註冊失敗:" + error);
        console.error("註冊失敗:", error);
        this.show_register = true;
        this.show_verify = false;
        this.show_success = false;
      }
    },

    attemptRegisterX() {
      const rst = this.register({
        username: this.username,
        password: this.password,
      });
      console.log("attempt register rst:", rst);
      if (rst.show_success) {
        console.log("註冊成功");
        this.show_verify = false;
        this.show_success = true;
      }
    },

    async resendVerificationCode() {
      this.correct_verficationCode = Math.floor(100000 + Math.random() * 900000).toString();
      const smsRst = await this.sendVeriCode();
      if (smsRst) {
        alert("驗證碼已重新發送");
      }
    },
  },
};
</script>

<style scoped>
/* @import "@/css/modal.css"; */




/* 主容器樣式 */
.parking-management-bg {
    background-color: transparent;
    width: 100%;
    min-height: 90vh;
  }
  
  /* 主標題樣式 */
  .page-title {
    margin-bottom: 0px;
  }
  


  /* 副標題樣式 */
  .title-description {
    /* //styleName: xl/regular; */
    font-family: Inter;
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  
    color: var(--gray13);
  
    /* 副標題較小 */
  }
  
  /* 表單容器樣式 */
  .form-content {
  
    width: 946px;
  
    margin: 0 auto;
    /* padding: 20px; */
    /* background-color: red; */
    border-radius: 8px;
    font-size: 1.2rem;
  }
  
  
  .sub-title {
    /* //styleName: 3xl/bold; */
    font-family: Inter;
    font-size: 28px;
    font-weight: 700;
    line-height: 38.08px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  
  
    color: var(--gray15);
    margin: 0px;
  
  }
  
  /* 表單卡片樣式 */
  .form-card {
    padding: 48px;
    margin-bottom: 20px;
    background-color: white;
    border-radius: 20px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
    display: flex;
    flex-direction: column;
    gap: 32px;
  
    box-sizing: border-box;
  
  }
  
  
  .two-columns {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 32px;
  }
  
  /* 表單組樣式 */
  .form-group {
    /* margin-bottom: 20px; */
    margin: 0px;
  }
  
  .form-group label {
    display: block;
    margin-bottom: 8px;
    margin-left: 0.2rem;
    /* color: #000; */
    /* 標籤文字顏色設為黑色 */
    font-weight: bold;
    text-align: left;
  
    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  
    color: var(--gray13);
  
  
  }
  
  /* 表單輸入元素樣式 */
  .form-group input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="date"],
  input[type="password"],
  select,
  textarea {
    /* padding: 0.8rem; */
    padding-left: 12.5px;
  
    /* 默認灰色邊框 */
  
    outline: none;
    /* 去除默認的聚焦外邊框 */
    box-shadow: none;
    /* 去除默認的聚焦陰影 */
    background-color: white;
    /* 保持背景白色 */
  
    width: 408px;
    height: 64px;
    gap: 0px;
    border-radius: 12px;
    /* border: 1px; */
    /* opacity: 0px; */
    border: 1.5px solid var(--gray11);
    /* border: 1px solid white; */
  
    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  
    color: var(--gray15);

    box-sizing: border-box;
  
  }
  
  
  /* 保持 select 的額外樣式 */
  .form-select {
  
    color: var(--gray15);
  
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    /* 默認灰色邊框 */
  }
  
  
  
  .form-submit-btn {
    /* width:100px; */
  
    background-color: var(--green03);
    color: white;
    border: none;
  
  
    cursor: pointer;
    display: block;
    margin: 0 auto;
  
    /* //styleName: xl/bold; */
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
  
  
  
  
    padding: 24px 40px 24px 40px;
    border-radius: 99px;
  
    margin-top: 40px;
    margin-bottom: 160px;
  
  
  
  }
  
  
  
  
  
  
  /* 針對螢幕寬度小於 560px */
  @media (max-width: 560px) {
    .form-content {
      max-width: 343px;
      /* 設定寬度為 343px */
      margin: 0 auto;
      /* 確保表單居中 */
      /* padding: 15px; */
      /* 調整內邊距 */
    }
  
  
  
    .title-description {
      /* //styleName: sm/regular; */
      font-family: Inter;
      font-size: 14px;
      font-weight: 400;
      line-height: 21.56px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
    }
  
    .form-card {
      padding: 16px;
      /* 調整內邊距 */
      gap: 20px;
      margin: 0px auto;
    }
  
    .two-columns {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;
    }
  
    .sub-title {
      /* //styleName: lg/bold; */
      font-family: Inter;
      font-size: 18px;
      font-weight: 700;
      line-height: 26.1px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
  
    }
  
    .form-group label {
  
      /* //styleName: sm/bold; */
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 21.56px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
  
      /* 調整字體大小 */
    }
  
    .form-group input[type="text"],
    input[type="text"],
    input[type="tel"],
    input[type="email"],
    input[type="password"],


    textarea,
    .form-select {
      width: 311px;
      height: 48px;
  
  
      /* //styleName: sm/bold; */
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 21.56px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
  
      box-sizing: border-box;
      /* background-color: red; */
  
    }
  
    .equipment-buttons {
      grid-template-columns: repeat(1, 1fr);
      /* 設定為單列 */
    }
  
    /* 調整設備按鈕的填充 */
    .equipment-button {
  
      width: 311px;
      height: 48px;
  
      /* //styleName: sm/bold; */
      font-family: Inter;
      font-size: 14px;
      font-weight: 700;
      line-height: 21.56px;
      /* text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none; */
  
    }
  
    .equipment-button .checkmark {
      position: absolute;
      top: 10px;
      left: 20px;
      font-size: 1.5rem;
      /* color: #008000; */
      /* 綠色對勾 */
    }
  
    .form-submit-btn {
      padding: 16px 32px 16px 32px;
  
      /* //styleName: lg/bold; */
      font-family: Inter;
      font-size: 18px;
      font-weight: 700;
      line-height: 26.1px;
      text-align: center;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
  
      margin-top: 20px;
      margin-bottom: 80px;
  
    }
  
  
  }
  


/*------------------------------------*/

.register_bg {
  background-color: var(--background-gray);
  /* 高度根據內容自適應 */
  
}

.register-container {
  display: flex;
  flex-direction: column;
  /* max-width: 27%; */
  /* margin: 88px auto 0 auto; */
  margin: 0px auto;
  padding: 10px;
  border-radius: 8px;
  background-color: #f9f9f9;
  padding-bottom: 5rem;

  /* min-height: 70vh; */
}



.form-content {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  /* padding: 20px; */

  min-height: 70vh;
}

.form-card {
  margin-bottom: 40px;

  /* padding-top: 0px; */
  padding-bottom: 0px;
  box-shadow: none;

  background-color: transparent;
}

.passwd-label-div {
  display: flex;
  justify-content: space-between;
}

.forgot-password-link {
  display: block;
  text-align: right;
  color: var(--green03);
  margin-top: 5px;
  /* margin-bottom: 10px; */

  /* font-family: Inter; */
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: right;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

}

.form-submit-btn {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 99px;
  background-color: var(--green03);
  color: white;
  margin-top: 20px;
  margin-bottom: 0px;
}

button:hover {
  background-color: var(--green01);
}

.register-link {
  margin-top: 0px;
  /* font-size: 0.9rem; */
  color: #666;

  /* font-family: Inter; */
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  /* text-decoration-line: underline; */
  text-decoration-style: solid;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  /* margin-bottom: 100px; */

}

.register-link a {
  color: var(--green03);
  font-weight: bold;
  text-decoration: none;
  text-decoration-line: underline;
}


@media screen and (max-width: 560px) {
  .form-content {
    /* padding: 20px; */
    padding: 0px;
    width: 344px;
  }

  .form-card {
    padding: 15px;

    width: 343px;
    margin-bottom: 10px;
    /* background-color: red; */
  }

  .forgot-password-link {
    font-size: 14px;
    margin-top: 2px;
  }

  button {
    padding: 10px;

    /* //styleName: md/bold; */
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

  }

  .register-link {
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    /* text-align: right; */

  }
}
</style>
